module.exports = __webpack_public_path__ + "img/unmarked-badge.95bfbfa7.svg";